var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1668_4125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1668_4125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75776 17.0829C4.38262 17.0829 4.06554 16.9534 3.80651 16.6943C3.54748 16.4353 3.41797 16.1182 3.41797 15.7431V5.25599C3.41797 4.87516 3.54644 4.55321 3.80339 4.29016C4.06033 4.02696 4.37845 3.90231 4.75776 3.9162H11.7417L10.6584 4.99953H4.75776C4.69359 4.99953 4.63484 5.02627 4.58151 5.07974C4.52804 5.13307 4.5013 5.19182 4.5013 5.25599V15.7431C4.5013 15.8072 4.52804 15.866 4.58151 15.9193C4.63484 15.9728 4.69359 15.9995 4.75776 15.9995H15.2448C15.309 15.9995 15.3678 15.9728 15.4211 15.9193C15.4746 15.866 15.5013 15.8072 15.5013 15.7431V9.81036L16.5846 8.72703V15.7431C16.5846 16.1182 16.4551 16.4353 16.1961 16.6943C15.9371 16.9534 15.62 17.0829 15.2448 17.0829H4.75776ZM8.41797 12.0829V9.57641L15.6969 2.29766C15.8122 2.18224 15.9335 2.10182 16.0607 2.05641C16.1878 2.01099 16.321 1.98828 16.4605 1.98828C16.6017 1.98828 16.7376 2.01099 16.868 2.05641C16.9985 2.10182 17.1184 2.17807 17.2276 2.28516L18.1711 3.20786C18.2918 3.32328 18.3776 3.44981 18.4284 3.58745C18.4791 3.72509 18.5044 3.8646 18.5044 4.00599C18.5044 4.14766 18.4803 4.28481 18.4319 4.41745C18.3836 4.55009 18.302 4.67356 18.1871 4.78786L10.8842 12.0829H8.41797ZM9.5013 10.9995H10.4357L15.6086 5.82641L15.1519 5.34891L14.6584 4.8762L9.5013 10.0333V10.9995Z",
    fill: "#226EB7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit_square.7c8223ca7f0e30a4568ece71be4a8ef2.svg";
export { ForwardRef as ReactComponent };